import invert from 'lodash/invert';

import { FeedbackStep } from '../feedback/stepComponents/FeedbackStep';
import { CongratulationsStep } from '../stepComponents/CongratulationsStep';
import { WellbeingCheckInStep } from '../stepComponents/WellbeingCheckInStep';
import { WellbeingScoreStep } from '../stepComponents/WellbeingScoreStep';
import {
    ProgramEnum,
    ProgramSharedStep,
    ProgramSharedStepProps,
    ProgramsState,
    ProgramWeekEnum,
} from './programs';

export const programsIds = [ProgramEnum.CP, ProgramEnum.PFA, ProgramEnum.CBT];

export const multipleWeeksProgramsIds = [ProgramEnum.CP, ProgramEnum.CBT];

export const programWeeksIds = [
    ProgramWeekEnum.WeekOne,
    ProgramWeekEnum.WeekTwo,
    ProgramWeekEnum.WeekThree,
    ProgramWeekEnum.WeekFour,
    ProgramWeekEnum.WeekFive,
    ProgramWeekEnum.WeekSix,
    ProgramWeekEnum.WeekSeven,
    ProgramWeekEnum.WeekEight,
];

const sharedStepsProps: ProgramSharedStepProps[] = [
    {
        id: ProgramSharedStep.WellbeingCheckInStep,
        component: WellbeingCheckInStep,
        noButtons: true,
        tooltip: 'Wellbeing Check-In',
    },
    {
        id: ProgramSharedStep.WellbeingScoreStep,
        component: WellbeingScoreStep,
        tooltip: 'Wellbeing Score',
    },
    {
        id: ProgramSharedStep.FeedbackStep,
        component: FeedbackStep,
        tooltip: 'Feedback',
        noButtons: true,
        grayBackground: true,
    },
    {
        id: ProgramSharedStep.CongratulationsStep,
        component: CongratulationsStep,
        tooltip: 'Congratulations!',
    },
];

export const programsDefaultState: ProgramsState = {
    programsProgress: {},
    programsProgressFetched: false,
    sharedStepsProps,
};

export const programWeekNumberById = {
    [ProgramWeekEnum.WeekOne]: 0,
    [ProgramWeekEnum.WeekTwo]: 1,
    [ProgramWeekEnum.WeekThree]: 2,
    [ProgramWeekEnum.WeekFour]: 3,
    [ProgramWeekEnum.WeekFive]: 4,
    [ProgramWeekEnum.WeekSix]: 5,
    [ProgramWeekEnum.WeekSeven]: 6,
    [ProgramWeekEnum.WeekEight]: 7,
};

export const programWeekIdByNumber = invert(programWeekNumberById);
